import React from "react"
import NavItem from "./NavItem"

class WizardNav extends React.Component {
    constructor(props){
        super(props)
        this.state={
            stepsTitles :[
                "Reservation",
                "Conditional Sales",
                "Official Sales",
                "House Construction",
                "Letter of Guarantee",
                "House Turnover",
                "House Turnover RTO",
                "Title Transfer",
                "Collateral Docs"
            ],
            step: 1
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.state.step !== prevState.step){
            this.props.goToStep(this.state.step)
        }
    }

    goToStep = (stepTitle) => {
        this.setState({step:this.state.stepsTitles.indexOf(stepTitle) + 1})
    }

    render() {
        return (
        <div className="stepContainer">
            {this.state.stepsTitles.map(stepTitle => {
                return <NavItem 
                            stepTitle={stepTitle} 
                            currentStep={this.state.stepsTitles[this.props.currentStep - 1]}
                            goToStep={this.goToStep}
                        />
            })}
        </div>)
    }
}

export default WizardNav
